<template>
    <a-modal :title="`${props.tableColumnsData.full_name} - 档案管理`" :width="1000" :open="true" @cancel="cancel">
        <template #footer>
            <div class="d-flex">
                <template v-if="props.tableColumnsData.permission_show_zipzc == 1">
                    <div>
                        <!-- 设立的才能通过电子化账号获取章程 -->
                        <a-button :loading="state.downZcLoading"
                            v-if="props.tableColumnsData.main_type == 1 && props.tableColumnsData.registration_type != 2 && props.tableColumnsData.business_type == 1"
                            type="primary" @click="handleDownload">获取公司章程</a-button>
                        <a-button type="primary" @click="handleScreenshot" :loading="state.screenshotLoading"
                            v-if="props.tableColumnsData.permission_show_zipjd == 1">进度截图</a-button>
                    </div>
                </template>
                <template v-else>&nbsp;</template>
                <div v-if="user.id == 1">
                    <a-form-item label="查询已删除档案" name="recycle">
                        <a-switch :checkedValue="1" :unCheckedValue="2" checked-children="是" un-checked-children="否"
                            v-model:checked="state.recycle" @change="queryDetail"></a-switch>
                        <a-divider type="vertical" />
                        <a-switch :checkedValue="1" :unCheckedValue="2" checked-children="正式合同"
                            un-checked-children="所有档案" v-model:checked="state.is_formal"
                            @change="queryDetail"></a-switch>
                    </a-form-item>
                </div>
                <div>
                    <a-divider type="vertical" />
                    <a-button @click="cancel">取消</a-button>
                    <a-button type="primary" @click="handleRecord">添加档案</a-button>
                </div>
            </div>
        </template>
        <a-table size="small" :loading="state.ownershipTableLoading" style="margin-bottom: 30px" :columns="columns"
            rowKey="name" :data-source="shareOwnership" :pagination="false">
            <template #bodyCell="{ column, record, text }">
                <template v-if="column.dataIndex == 'type_name'">
                    <div :style="record.deleted_at ? { borderLeft: '5px dashed #000', paddingLeft: '10px' } : {}">
                        {{ text }}
                        <span v-if="record.is_formal == 1">【正式】</span>
                    </div>
                </template>
                <template v-if="column.dataIndex === 'options'">
                    <a v-if="record.status == 2"
                        :href="'/hncskaiyela/admin/v1/templateZipDown?id=' + record.id + '&token=' + token"
                        target="_blank"> 下载</a>
                    <a-divider type="vertical" />
                    <a-popconfirm title="确定删除此档案?" @confirm="handleDelete(record)">
                        <a style="color: red">删除</a>
                    </a-popconfirm>
                    <a-divider type="vertical" />
                    <a @click="handleTuiS(record)">推送</a>
                </template>
                <template v-else-if="column.dataIndex === 'name'">
                    <div v-if="record.remark">{{ record.remark }}</div>
                    <div v-else>-</div>
                    <div v-if="record.type == 6">防伪码：{{ record.ukeycode }}</div>
                </template>
                <template v-else-if="column.dataIndex === 'url'">
                    <div v-if="[1, 2, 3, 5, 6, 7, 8, 12, 14, 21, 22, 23, 24, 25, 26].includes(record.type)"
                        class="image-list">
                        <template v-for="(item, index) in text">
                            <a-image
                                v-if="item.url.endsWith('png') || item.url.endsWith('jpg') || item.url.endsWith('jpeg')"
                                :width="60" :height="60" :key="index"
                                :src="$store.state.user.image_domain + item.url"></a-image>
                            <a :href="$store.state.user.image_domain + item.url" target="_blank" v-else>
                                <a-image v-if="item.url.endsWith('pdf')" :width="60" :height="60" :key="index"
                                    :preview="false"
                                    :src="$store.state.user.image_domain + '/uploads/images/image-pdf.png'"></a-image>
                                <text v-else>{{ item.name }}</text>
                            </a>
                        </template>
                    </div>
                    <div v-else>-</div>
                </template>
                <template v-else-if="column.dataIndex === 'operator_admin_info'">
                    {{ text?.nickname ? text.nickname : '-' }}
                </template>
            </template>
        </a-table>
        <a-modal title="添加档案" :bodyStyle="{ padding: '20px', paddingBottom: '0' }" :width="700" :destroyOnClose="true"
            :open="state.createOpen" @ok="createOk" @cancel="
                () => {
                    state.createOpen = false
                }
            ">
            <a-form :model="createForm" v-bind="formLayout" ref="createFormRef">
                <a-form-item label="类型" required>
                    <a-select v-model:value="createForm.type" placeholder="请选择档案类型">
                        <a-select-option v-for="(item, index) in typeList" :key="item.value">{{ item.label
                        }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="附件" required>
                    <Upload :upload_path="props.tableColumnsData.upload_path"
                        :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png', 'mp3', 'mp4', 'zip', 'rar', '7z']"
                        :customerName="props.tableColumnsData.entityNameToRegister.full_name" uploadType="text"
                        v-model:value="createForm.url" :limitation="99" uploadText="上传附件">
                    </Upload>
                </a-form-item>
                <a-form-item label="备注">
                    <a-input placeholder="请输入备注" v-model:value="createForm.remark"></a-input>
                </a-form-item>
            </a-form>
        </a-modal>
        <!-- 变更的截图需要登录 -->
        <a-modal :title="`${props.tableColumnsData.full_name}变更登录`" :keyboard="false" :maskClosable="false" :width="800"
            :open="state.openQrcode" :footer="null" @cancel="qrcodeCancel">
            <a-form @finish="onRegisterFinish" v-bind="formLayout" :model="registerFormState" :rules="rules">
                <a-form-item label="核验方式">
                    <a-radio-group v-model:value="registerFormState.type" button-style="solid">
                        <a-radio :value="1" v-if="props.tableColumnsData.business_type == 2">短信验证码登录</a-radio>
                        <a-radio :value="2">授权登录</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="扫码登录" v-show="registerFormState.type == 2">
                    <div class="d-flex flex-left" v-show="state.deadline > 0">
                        <img :src="state.qrcode" />
                        <a-statistic-countdown format="mm:ss" title="登录倒计时" :value="state.deadline"
                            @finish="onStatisticFinish" />
                    </div>
                    <div v-show="state.deadline == 0">
                        <a-button type="primary" @click="handleScreenshot">重新获取</a-button>
                    </div>
                </a-form-item>
                <div v-if="registerFormState.type == 1">
                    <a-form-item label="统一社会信用代码" name="social_credit_code" required>
                        <a-input v-model:value="registerFormState.social_credit_code" placeholder="请输入统一社会信用代码">
                        </a-input>
                    </a-form-item>
                    <a-form-item label="联络员姓名" name="name" required v-if="registerFormState.name">
                        <a-input v-model:value="registerFormState.name" :disabled="true"> </a-input>
                    </a-form-item>
                    <a-form-item label="联络员身份证号码" name="id_card_number" required>
                        <a-input v-model:value="registerFormState.id_card_number" placeholder="联络员身份证号码"> </a-input>
                    </a-form-item>
                    <a-form-item label="联络员电话号码" name="phone_number">
                        <a-input v-model:value="registerFormState.phone_number" placeholder="请输入联络员电话号码"
                            :disabled="true">
                        </a-input>
                    </a-form-item>
                    <a-form-item label="验证码" required>
                        <div class="d-flex">
                            <a-input v-model:value="registerFormState.code" placeholder="请输入验证码"> </a-input><a-button
                                type="primary" class="ml-1x" @click="onGetCodeClick"
                                :disabled="state.getCodeDisabled">获取验证码</a-button>
                        </div>
                    </a-form-item>
                    <a-form-item :wrapper-col="{ offset: 7, span: 16 }">
                        <a-button type="primary" html-type="submit">确定</a-button>
                    </a-form-item>
                </div>
            </a-form>
        </a-modal>
    </a-modal>
</template>

<script lang="ts" setup>
import Upload from '@/components/base/Upload.vue'
import { reactive, onMounted, ref } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import ls from '@/utils/Storage'
import { useStore } from 'vuex'
const $store = useStore()
const token = ls.get('ACCESS_TOKEN').replace('Bearer ', '')
const user = ls.get('USER_INFO')
interface tableData {
    isEdit: boolean
}
const emit = defineEmits(['cancel'])
const columns: Array<Object> = [
    {
        title: '资料类型',
        dataIndex: 'type_name',
        width: 250
    },
    {
        title: '资料名称',
        dataIndex: 'name',
        width: 200
    },
    {
        title: '资源',
        dataIndex: 'url',
        width: 450
    },
    {
        title: '创建时间',
        dataIndex: 'created_at',
        width: 200
    },
    {
        title: '创建人',
        dataIndex: 'operator_admin_info',
        width: 200
    },
    {
        title: '操作',
        dataIndex: 'options',
        width: 300
    }
]

const typeList = [
    {
        label: '营业执照照片资料',
        value: 8
    },
    {
        label: '章程资料',
        value: 9
    },
    {
        label: '电子化资料',
        value: 1
    },
    {
        label: '现场资料',
        value: 2
    },
    {
        label: '租赁合同',
        value: 4
    },
    {
        label: '银行开户资料',
        value: 3
    },
    {
        label: '续费催款告知书',
        value: 5
    },
    {
        label: '解除协议',
        value: 6
    },
    {
        label: '移出异常资料',
        value: 7
    },

    {
        label: '代理记账协议',
        value: 10
    },
    {
        label: '列入异常资料',
        value: 11
    },
    {
        label: '移交线索关店资料',
        value: 12
    },
    {
        label: '刻章资料',
        value: 13
    },
    {
        label: '进度截图',
        value: 14
    },
    {
        label: '与财务公司的代理合同',
        value: 15
    },
    {
        label: '其他资料',
        value: 101
    }
]
interface data {
    ownershipTableLoading: boolean
    downZcLoading: boolean
    createOpen: boolean
    screenshotLoading: boolean
    openQrcode: boolean
    qrcode: string
    deadline: number
    getCodeDisabled: boolean
    recycle: number
    is_formal: number
}
const state = reactive<data>({
    ownershipTableLoading: false,
    downZcLoading: false,
    createOpen: false,
    screenshotLoading: false,
    openQrcode: false,
    qrcode: '',
    deadline: 0,
    getCodeDisabled: false,
    recycle: 2,
    is_formal: 2,
})
const createForm = reactive<any>({
    type: 8
})
const createFormRef = ref()
const formLayout = {
    labelCol: {
        xs: { span: 6 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 14 },
        sm: { span: 14 }
    }
}
const shareOwnership = ref<tableData[]>([])

onMounted(() => {
    queryDetail()
})
const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => { }
    }
})

const handleDelete = (record) => {
    let requestParam = {
        url: '/admin/v1/templateZip/' + record.id,
        method: 'delete'
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            queryDetail()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}

const queryDetail = () => {
    state.ownershipTableLoading = true
    let requestParam = {
        url: '/admin/v1/templateZipList',
        method: 'post',
        data: {
            customer_id: props.tableColumnsData.id,
            limit: 'all',
            recycle: state.recycle,
            is_formal: state.is_formal
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            shareOwnership.value = res.data.list
            state.ownershipTableLoading = false
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
const cancel = () => {
    emit('cancel')
}
const handleRecord = () => {
    state.createOpen = true
}
const handleDownload = () => {
    state.downZcLoading = true
    let requestParam = {
        url: '/admin/v1/customerDownZc?customer_id=' + props.tableColumnsData.id,
        method: 'get'
    }
    baseService(requestParam)
        .then((res: any) => {
            state.downZcLoading = false
            message.success(res.msg ? res.msg : '获取成功')
            queryDetail()
        })
        .catch((res) => {
            state.downZcLoading = false
            message.error(res.msg ? res.msg : '获取失败')
        })
}
const createOk = () => {
    createFormRef.value.validate().then(() => {
        let requestParam = {
            url: '/admin/v1//templateZipAppend',
            method: 'post',
            data: Object.assign({ customer_id: props.tableColumnsData.id }, createForm)
        }
        baseService(requestParam)
            .then((res: any) => {
                message.success(res.msg ? res.msg : '添加成功')
                state.createOpen = false
                const keys = Object.keys(createForm)
                let obj: { [name: string]: any } = {}
                keys.forEach((item) => {
                    obj[item] = null
                })
                Object.assign(createForm, obj)
                queryDetail()
            })
            .catch((res) => {
                message.error(res.msg ? res.msg : '添加失败')
            })
    })
}
//进度截图
let timer = ref()
const qrcodeCancel = () => {
    state.openQrcode = false
    clearInterval(timer.value)
}
const registerFormState = reactive<any>({
    code: null,
    name: '',
    id_card_number: null,
    phone_number: null,
    type: 1, //短信验证码登录
    id: null
})
const finalScreen = () => {
    qrcodeCancel()
    state.screenshotLoading = true
    let requestParam = {
        url: '/admin/v1/templateZipscreenshot',
        method: 'post',
        data: { customer_id: props.tableColumnsData.id }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg ? res.msg : '截图中')
        })
        .catch((res) => {
            message.error(res.msg ? res.msg : '截图失败')
        })
        .finally(() => {
            state.screenshotLoading = false
        })
}
const handleScreenshot = () => {
    if (props.tableColumnsData.business_type == 1) {
        finalScreen()
    } else {
        if (props.tableColumnsData.business_type == 3) {
            registerFormState.type = 2//跨区迁入暂只支持扫码登录
        }
        getMigrateSmsCode()
        // 迁入的需要弹出登录信息
        let param = {
            url: '/admin/v1/getAlterationQrcodeStatus?customer_id=' + props.tableColumnsData.id,
            method: 'get'
        }
        baseService(param)
            .then((res: any) => {
                state.openQrcode = true
                if (res.data.status == 1) {
                    finalScreen()
                } else if (registerFormState.type == 2) {
                    let queryParam = {
                        url: '/admin/v1/getAlterationQrcodeUrl?customer_id=' + props.tableColumnsData.id,
                        method: 'get'
                    }
                    baseService(queryParam)
                        .then((res: any) => {
                            timer.value = setInterval(() => {
                                let param = {
                                    url: '/admin/v1/getAlterationQrcodeStatus?customer_id=' + props.tableColumnsData.id,
                                    method: 'get'
                                }
                                baseService(param).then((res: any) => {
                                    if (res.data.status == 1) {
                                        finalScreen()
                                    }
                                })
                            }, 3000)
                            state.openQrcode = true
                            state.deadline = Date.now() + 1000 * 120
                            state.qrcode = res.data.base64_image
                        })
                        .catch((res) => {
                            if (res.msg) {
                                message.error(res.msg)
                            } else {
                                message.error('操作失败')
                            }
                        })
                }
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
            })
    }
}
const rules = {}
const onGetCodeClick = () => {
    state.getCodeDisabled = true
    let requestParam = {
        url:
            '/admin/v1/getMigrateSmsCode?id_card_number=' +
            registerFormState.id_card_number +
            '&social_credit_code=' +
            registerFormState.social_credit_code +
            '&customer_id=' +
            props.tableColumnsData.id +
            '&phone_number=' +
            registerFormState.phone_number +
            '&name=' +
            registerFormState.name,
        method: 'get'
    }
    baseService(requestParam)
        .then((res: any) => {
            registerFormState.name = res.data.liaisonName
            registerFormState.phone_number = res.data.tel
            message.success(res.msg)
        })
        .catch((res) => {
            state.getCodeDisabled = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取失败')
            }
        })
}
const onStatisticFinish = () => {
    // data.openQrcode = false
    state.qrcode = ''
    state.deadline = 0
}
// 提交验证码
const onRegisterFinish = () => {
    if (!registerFormState.code) {
        message.error('请输入验证码')
        return
    }
    let requestParam = {
        url: '/admin/v1/setMigrateSmsCode',
        method: 'post',
        data: {
            customer_id: props.tableColumnsData.id,
            verify_code: registerFormState.code,
            name: registerFormState.name,
            phone_number: registerFormState.phone_number,
            id_card_number: registerFormState.id_card_number,
            social_credit_code: registerFormState.social_credit_code
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            // 提交进度截图
            finalScreen()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
const getMigrateSmsCode = () => {
    let requestParam = {
        url: '/admin/v1/getLiaisonInfo?customer_id=' + props.tableColumnsData.id,
        method: 'get'
    }
    baseService(requestParam)
        .then((res: any) => {
            registerFormState.social_credit_code = props.tableColumnsData.social_credit_code
            registerFormState.id = res.data.id
            registerFormState.name = res.data.name
            registerFormState.id_card_number = res.data.id_card_number
            registerFormState.phone_number = res.data.phone_number
            if (res.data.is_change) {
                message.warn('检测到联络员有变化,正在重新刷新列表')
                queryDetail()
            }
        })
        .catch((res) => { })
}
const handleTuiS = (record) => {
    const hide = message.loading({
        content: '推送中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/pushZipMessage?zip_id=' + record.id,
        method: 'get'
    }
    baseService(requestParam)
        .then((res: any) => {
            setTimeout(hide, 500)
            message.success(res.msg ? res.msg : '推送成功')
        })
        .catch((res) => {
            setTimeout(hide, 500)
            message.error(res.msg ? res.msg : '推送失败')
        })
}
</script>

<style lang="less" scoped>
.d-flex {
    justify-content: space-between;
    align-items: center;
}

.image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}
</style>
